import { message } from 'antd';
import { getProviderAppointmentList } from 'api/inbox';
import { useCallback, useEffect, useState } from 'react';
import { TGetProviderAppointmentListInput } from 'types/inbox';

const useGetProviderAppointmentList = ({
    current = 1,
    size = 10,
    type = 'Upcoming',
    clientId,
    autoFetch = true,
}: TGetProviderAppointmentListInput & { autoFetch?: boolean }): [any[], boolean, (c: number, s: number, t: 'Upcoming' | 'Past', cid?: number) => Promise<any[]>] => {
    const [appointmentList, setAppointmentList] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const fetch = useCallback(async (c: number, s: number, t: 'Upcoming' | 'Past', cid?: number) => {
        if (!cid) {
            return [];
        }

        setLoading(true);
        let res: any[] = [];
        try {
            const resp = await getProviderAppointmentList({ current: c, size: s, type: t, clientId: cid });
            if (resp && !resp.error) {
                const data = resp?.data?.data?.records || [];
                res = data;
                setAppointmentList(data);
            } else {
                message.error(resp?.message);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }

        return res;
    }, []);

    useEffect(() => {
        if (clientId && autoFetch) {
            fetch(current, size, type, clientId);
        }
    }, [current, size, type, clientId, fetch, autoFetch]);

    return [appointmentList, loading, fetch];
};

export default useGetProviderAppointmentList;
